import React, { useState, useEffect } from 'react';
import ChronusApi from '../../../../../services/ChronusApi';
import { useSelector, useDispatch } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';

const RsvpReminder = ({ eventId, checked, text, reminderUpdateUrl }) => {
  const dispatch = useDispatch();
  const reminderValue = useSelector(state => state.eventsListing.eventIdReminderMap[eventId]);
  const [reminder, setReminder] = useState(checked);
  const inputElementId = `remind-me-${eventId}`;

  useEffect(() => {
    if(reminderValue !== undefined && reminderValue !== reminder)
      setReminder(reminderValue);
  }, [reminderValue]);

  useEffect(() => {
    if (reminder !== undefined && reminderValue !== reminder)
      dispatch(eventsListingActions.updateEventIdReminderMap({ eventId, reminder }));
  }, [reminder]);


  const handleReminderChange = (reminder) => {
    ChronusApi.postUrlJSON(
      reminderUpdateUrl, { reminder }
    ).then(({ data }) => {
      ChronusValidator.ErrorManager.ShowPageFlash(true, data.message);
    }).catch(_error => {
      ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
    });
    setReminder(reminder);
  }

  return(
    <div className='form-check form-check-inline m-t-sm'>
      <input id={ inputElementId } className='form-check-input' type='checkbox' checked={ reminder } onChange={ (event) => handleReminderChange(event.target.checked) } />
      <label className='form-check-label font-weight-normal pl-1' htmlFor={ inputElementId }> { text } </label>
    </div>
  )
};

export default RsvpReminder;